import { render } from "./ModalVotacionGot.vue?vue&type=template&id=d6eedcc2"
import script from "./ModalVotacionGot.vue?vue&type=script&lang=js"
export * from "./ModalVotacionGot.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__